module.exports = __webpack_public_path__ + "img/Grenada.c32320af.png";